import { z } from "zod";
export const dmaValidationResponseDtoSchema = z.object({
    id: z.string(),
});
